// True when the primary pointer cannot hover and is coarse — phones, tablets, touch-first laptops.
// This is an input-capability check, not a device or viewport check: a wide iPad is still touch
// input, and a desktop window dragged narrow is not. Use CSS breakpoints for layout decisions.
export function IsTouchInput() {
  return window.matchMedia("(hover: none) and (pointer: coarse)").matches;
}
